import { UserType } from '../models/report-models';
import { BackgroundReportHeader } from './components/BackgroundReportHeader';
import { BackgroundReportSummary } from './components/BackgroundReportSummary';
import { BackgroundReportEvictions } from './components/BackgroundReportEvictions';
import { BackgroundReportCriminal } from './components/BackgroundReportCriminal';
import { BackgroundReportFooter } from './components/BackgroundReportFooter';
import type { ApplicationData, ConditionallyApprove, EmitMetric, Log, TrackEvent } from '../models/report-models';
import { ToastProvider } from '@zillow/constellation';
import type { BackgroundReport } from '@zg-rentals/ts-capps-client';
import { formatDate } from '@zg-rentals/formatters';

interface BackgroundReportProps {
  userType?: UserType;
  backgroundReport: BackgroundReport;
  zipCode: string;
  applicationData?: ApplicationData;
  requestedDateTime: Date | string | null | undefined;
  expirationDateTime: Date | string | null | undefined;
  isInMobileWebView?: boolean;
  trackEvent: TrackEvent;
  emitMetric: EmitMetric;
  log: Log;
  requiresConditionalApproval: boolean;
  conditionallyApprove: ConditionallyApprove;
  isConditionallyApproving: boolean;
  onDownloadPdf?: () => void;
  isDownloadingPdf?: boolean;
}

export function BackgroundReport({
  userType = UserType.Renter,
  backgroundReport,
  zipCode,
  applicationData,
  requestedDateTime,
  expirationDateTime,
  isInMobileWebView = false,
  trackEvent,
  emitMetric,
  log,
  requiresConditionalApproval,
  conditionallyApprove,
  isConditionallyApproving,
  onDownloadPdf,
  isDownloadingPdf,
}: BackgroundReportProps) {
  const formattedRequestedDateTime = formatDate(requestedDateTime);
  const formattedExpirationDateTime = formatDate(expirationDateTime);

  return backgroundReport ? (
    <div id="background-report">
      <ToastProvider>
        <BackgroundReportHeader
          backgroundReport={backgroundReport}
          isInMobileWebView={isInMobileWebView}
          onDownloadPdf={onDownloadPdf}
          isDownloadingPdf={isDownloadingPdf}
          trackEvent={trackEvent}
        />
        <BackgroundReportSummary
          userType={userType}
          backgroundReport={backgroundReport}
          zipCode={zipCode}
          requestedDateTime={formattedRequestedDateTime}
          expirationDateTime={formattedExpirationDateTime}
          requiresConditionalApproval={requiresConditionalApproval}
        />
        <BackgroundReportEvictions userType={userType} backgroundReport={backgroundReport} emitMetric={emitMetric} />
        <BackgroundReportCriminal
          userType={userType}
          backgroundReport={backgroundReport}
          applicationData={applicationData}
          emitMetric={emitMetric}
          log={log}
          requiresConditionalApproval={requiresConditionalApproval}
          conditionallyApprove={conditionallyApprove}
          isConditionallyApproving={isConditionallyApproving}
        />
        <BackgroundReportFooter userType={userType} emitMetric={emitMetric} />
      </ToastProvider>
    </div>
  ) : null;
}
